import React from 'react';

const useScrollPosition = (): { scrollTop: number } => {
  const [scrollTop, setScrollPosition] = React.useState(0);

  const onScroll = () => {
    const scrollTop = document.documentElement?.scrollTop || document.body.scrollTop;
    setScrollPosition(scrollTop);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return {
    scrollTop,
  };
};

export default useScrollPosition;
